import { Component, OnInit, inject } from '@angular/core';
import { MainMenuConfig, MainMenuItem, SubMenuItem } from '../main-menu';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import {
    MatAutocomplete,
    MatAutocompleteSelectedEvent,
    MatAutocompleteTrigger,
    MatOption,
} from '@angular/material/autocomplete';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PhitoSessionService } from '../../../services/phito-session.service';
import { Params, Router } from '@angular/router';
import { PhitoRoute } from '../phito-routes';
import { RouterService } from '../../../services/router.service';

@Component({
    selector: 'phito-navigate-dialog',
    imports: [
        MatLabel,
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        MatFormField,
        MatInput,
        MatAutocomplete,
        MatOption,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        AsyncPipe,
    ],
    templateUrl: './navigate-dialog.component.html',
    styleUrl: './navigate-dialog.component.scss',
})
export class NavigateDialogComponent implements OnInit {
    private readonly sessionService = inject(PhitoSessionService);
    protected dialogRef = inject<MatDialogRef<NavigateDialogComponent>>(MatDialogRef);
    private routerService = inject(RouterService);
    data: MainMenuItem[] = inject(MAT_DIALOG_DATA);

    options: SubMenuItem[] = [];

    searchCtrl = new FormControl();
    filteredOptions!: Observable<SubMenuItem[]>;

    ngOnInit() {
        for (const mainItem of this.data) {
            for (const subItem of mainItem.subMenuItems) {
                if (this.sessionService.hasPermission(subItem.permission, 'NavigateDialogComponent')) {
                    this.options.push(subItem);
                }
            }
        }

        this.filteredOptions = this.searchCtrl.valueChanges.pipe(
            startWith(''),
            map((value) => {
                const filteredValue = typeof value === 'string' ? value : value.name;
                return this.options.filter((option) =>
                    option.displayName.toLowerCase().includes(filteredValue?.toLowerCase() ?? ''),
                );
            }),
        );
    }

    navigate(event: MatAutocompleteSelectedEvent): void {
        this.dialogRef.close();
        const nav: SubMenuItem = event.option.value;
        this.routerService.navSubMenu(nav);
    }

}
